var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.56 12.7451L8.55 9.73506C8.25 9.43506 7.76 9.43506 7.46 9.73506L4.45 12.7351L4.3 12.6151C4.04 12.4151 3.82 12.1951 3.62 11.9451L3.5 11.8051L6.51 8.79506C6.88 8.42506 7.36 8.22506 7.84 8.18506C7.89 8.18506 7.94 8.18506 7.99 8.18506C8.04 8.18506 8.09 8.18506 8.14 8.18506C8.63 8.22506 9.1 8.42506 9.48 8.79506L12.49 11.8051L12.37 11.9551C12.17 12.1951 11.95 12.4251 11.7 12.6251L11.55 12.7451H11.56Z",
    fill: "#FF3300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44 3.25488L7.45 6.26488C7.75 6.56488 8.24 6.56488 8.54 6.26488L11.55 3.25488L11.7 3.37488C11.96 3.57488 12.18 3.79488 12.38 4.04488L12.5 4.19488L9.49 7.20488C9.12 7.57488 8.64 7.77488 8.16 7.81488C8.11 7.81488 8.06 7.81488 8.01 7.81488C7.96 7.81488 7.91 7.81488 7.86 7.81488C7.37 7.77488 6.9 7.57488 6.52 7.20488L3.5 4.19488L3.62 4.04488C3.82 3.80488 4.04 3.57488 4.29 3.37488L4.44 3.25488Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.04057e34575d8111ebc2a6b276f3a830.svg";
export { ForwardRef as ReactComponent };